import { render } from "./StarRating.vue?vue&type=template&id=2819109a&scoped=true"
import script from "./StarRating.vue?vue&type=script&lang=js"
export * from "./StarRating.vue?vue&type=script&lang=js"

import "./StarRating.vue?vue&type=style&index=0&id=2819109a&scoped=true&lang=css"

import exportComponent from "/Users/sophiasharif/Desktop/projects/i-hate-pinia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2819109a"]])

export default __exports__